import styled from 'styled-components'
import { Link, NavLink } from 'react-router-dom'

import { COLOURS, BREAKPOINTS } from 'resources'
import { ReactComponent as LinkArrow } from 'resources/images/icons/link-arrow.svg'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0 30px 120px;
  flex: 1;
  overflow-y: auto;

  @media (min-width: ${BREAKPOINTS.md}) {
    padding: 0 30px 30px;
  }
`

// Nav Menu Items Section
export const NavMenuItemsContainer = styled.div`
  flex: 1;
  margin-top: 40px;
`

export const NavMenuItemLinkContainer = styled(NavLink)`
  display: flex;
  align-items: center;
  color: ${COLOURS.black};
  margin-bottom: 5px;
  font-weight: 500;
  transition: opacity 0.3s;

  &:hover {
    text-decoration: none;

    &:not(.active) {
      color: ${COLOURS.black};
      opacity: 0.7;
    }
  }

  &.active {
    font-weight: bold;
    color: ${COLOURS.secondaryPurple1};

    &:hover {
      color: ${COLOURS.secondaryPurple1};
    }
  }
`

export const NavMenuItemIcon = styled.i`
  font-size: 24px;
  margin-right: 15px;
`

export const NavMenuItemLabel = styled.div`
  font-size: 18px;
`

export const SubMenuItemsContainer = styled.div`
  margin-left: 60px;
`

export const NavMenuSubItem = styled.div`
  display: flex;
  align-items: center;
  color: ${COLOURS.black};
  font-weight: 500;
  padding: 5px 10px;
  cursor: pointer;
  transition: opacity 0.3s;

  &:hover {
    color: ${COLOURS.black};
    opacity: 0.7;
  }

  &.active {
    font-weight: bold;
    color: ${COLOURS.secondaryPurple1};
  }
`

// Nav Menu RAF Card Section
export const NavMenuRAFCard = styled(Link)`
  background-color: ${COLOURS.secondaryPurple2};
  border-radius: 4px;
  padding: 20px;
  color: ${COLOURS.black};
  transition: color 0.3s, filter 0.3s;

  &:hover {
    text-decoration: none;
    color: ${COLOURS.black};
    filter: brightness(90%);
  }
`

export const NavMenuRAFTitle = styled.div`
  font-family: 'Druk', sans-serif;
  font-size: 36px;
  line-height: 1;
`

export const NavMenuRAFBottomContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
`

export const NavMenuRAFDescription = styled.div``

export const NavMenuRAFArrowIcon = styled.img`
  height: 12px;
`

// Bottom Section
export const NavMenuBottomContainer = styled.div`
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const SignOutLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${COLOURS.black};
  transition: opacity 0.3s;

  &:hover {
    text-decoration: none;

    &:not(.active) {
      color: ${COLOURS.black};
      opacity: 0.7;
    }
  }

  &.active {
    font-weight: bold;
    color: ${COLOURS.secondaryPurple1};
  }
`

export const SignOutText = styled.div`
  margin-right: 5px;
`

export const SignOutIcon = styled(LinkArrow)`
  rect {
    fill: ${COLOURS.neutralBlack};
  }
`
